export default "__VITE_ASSET__Ny7ay5vj__"